var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'app-night-mode': _vm.nightModeActive , 'app-light': !_vm.nightModeActive},style:([!_vm.$kmsTheme ? null : _vm.nightModeActive ? _vm.$kmsTheme.styles.darkHome : _vm.$kmsTheme.styles.lightHome, _vm.bgStyles]),attrs:{"id":"home-wrapper"}},[_c('home-page-content',{attrs:{"noticeBoard":_vm.noticeBoard,"messages":_vm.messages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }